import Vue from 'vue'

Vue.prototype.$listenNote = function (type, handler) {
  const obj = {
    type: type,
    handler: handler,
  };
  this.$store.commit('notes/addHandler', obj);
  return () => {
    this.$store.commit('notes/removeHandler', obj);
  }
};

const NotesStore = {
  namespaced: true,
  state: {
    authed: false,
    connected: false,
    conn: null,
    handlers: [],
    conn_retries: 0,
    busy: false,
  },
  mutations: {
    setAuthed(state, status) {
      state.authed = status;
    },
    setBusy(state, flag) {
      state.busy = flag;
    },
    setConnected(state, status) {
      state.connected = status;
    },
    saveConnection(state, conn) {
      state.conn = conn;
    },
    addHandler(state, handler) {
      state.handlers.push(handler);
    },
    removeHandler(state, handler) {
      state.handlers = state.handlers.filter(n => n != handler);
    },
    resetConnRetries(state) {
      state.conn_retries = 0;
    },
    incrementConnRetries(state) {
      state.conn_retries++;
    },
  },
  actions: {

    connect({ commit, dispatch, rootGetters, state }) {

      commit('setBusy', true);

      if(state.conn_retries > 10) {
        console.error('Websocket connection fail retries ended');
        commit('setBusy', false);
        return;
      }

      if(state.conn) {
        state.conn.close();
        commit('incrementConnRetries');
      }

      const conn = new WebSocket(process.env['VUE_APP_SERVICE_NOTES_API_WS_URL']);

      commit('saveConnection', conn);

      conn.onopen = function () {
        commit('setConnected', true);
        // console.log('opened');
        conn.send(rootGetters['user/token']);
        commit('resetConnRetries');
        commit('setBusy', false);
      };

      conn.onmessage = function (e) {
        const msg = JSON.parse(e.data);
        const handlers = state.handlers.filter(n => msg.type === n.type);
        handlers.forEach(n => {
          n.handler(msg.data);
        });
      };

      conn.onerror = function () {
        // console.log('error');
        conn.close();
      };

      conn.onclose = function () {
        // console.log('closed');
        commit('setConnected', false);
        setTimeout(function() {
          dispatch('connect');
        }, 5000);
      };
    },
  },
  getters: {
    isAuthed(state) {
      return state.authed;
    },
    isBusy(state) {
      return state.busy;
    },
    isConnected(state) {
      return state.connected;
    },
    socket(state) {
      return state.socket;
    },
  },
}

export { NotesStore };
